import BaseType from "./BaseType";
import Commons from "oc-commons/Commons";
import ConvexUvBufferGeometry from "oc-threejs/geometries/ConvexUvBufferGeometry";

export default class Brett extends BaseType(THREE.Mesh) {

    constructor(vsData) {
        super(vsData);
        this.material = new THREE.MeshBasicMaterial({ color: 0xe5e5e5 });
    }

    vsUpdate() {
        const verticesChanged = this.isVsChanged('vertices') || this.isVsChanged('geometry');
        const materialKeyOrArtikelnummerChanged = this.isVsChanged('materialKeyOrArtikelnummer');
        const sizeChanged = this.isVsChanged('size');
        const wireframe = this.isVsChanged('wireframe');
        if (verticesChanged) {
            this.updateGeometry();
        }
        if (materialKeyOrArtikelnummerChanged || sizeChanged || wireframe) {
            this.updateMaterial(materialKeyOrArtikelnummerChanged);
        }
        this.visible = this.vsData.visible;
        this.raycastVisibleTags = this.vsData.raycastVisibleTags;
    }

    updateGeometry() {
        if (this.vsData.box.isEmpty()) {
            console.error('a brett must not have zero volume', this.vsData);
            throw 'a brett must not have zero volume';
        }
        if (this.vsData.geometry) {
            this.geometry = this.vsData.geometry;
        } else {
            this.geometry = new ConvexUvBufferGeometry(this.vsData.vertices,this.vsData.getBasis());
        }
        if (this.edgeLines) {
            this.edgeLines.geometry = this.vsData.edgesGeometry || new THREE.EdgesGeometry(this.geometry);
        }
    }

    updateMaterial(materialKeyOrArtikelnummerChanged) {
        if (this.vsData.fixedMaterialKey === 'glas') {
            if (materialKeyOrArtikelnummerChanged) {
                this.disposeMaterial();
                this.setGlasMaterial();
                this.setEdgeMaterial(materialKeyOrArtikelnummerChanged, null);
            }
        } else if (this.vsData.fixedMaterialKey === 'alu') {
            if (materialKeyOrArtikelnummerChanged) {
                this.disposeMaterial();
                this.setAluMaterial();
                this.setEdgeMaterial(materialKeyOrArtikelnummerChanged, null);
            }
        } else if (this.vsData.fixedMaterialKey === 'schatten') {
            if (materialKeyOrArtikelnummerChanged) {
                this.disposeMaterial();
                this.setSchattenMaterial();
                this.setEdgeMaterial(materialKeyOrArtikelnummerChanged, null);
            }
        } else {
            const materialProduct = this.vsData.getMaterialProduct();
            this.setMaterialFromProduct(materialKeyOrArtikelnummerChanged, materialProduct);
            const kantenfarbe = _.get(materialProduct, 'Kantenfarbe', null);
            this.setEdgeMaterial(materialKeyOrArtikelnummerChanged, kantenfarbe);
        }
    }

    setGlasMaterial() {
        const material = {
            color: new THREE.Color(0xDDDDDD),
            transparent: true,
            opacity: APP.settings.getFloat('tuer_glas'),
            roughness: 0.1
            /* shininess: 10000 */
        }
        this.material = new THREE.MeshStandardMaterial(material);
        this.material.visible = !this.vsData.wireframe;
    }

    setAluMaterial() {
        const material = {
            color: new THREE.Color(0xDDDDDD),
        }
        const raum = APP.arrangement.raum.object3d;
        if (raum?.envmap) {
            material.envMap = raum.envmap;
            material.combine = THREE.MixOperation;
            material.reflectivity = 0.03;
        }
        this.material = new THREE.MeshPhongMaterial(material);
        this.material.visible = !this.vsData.wireframe;
    }

    setSchattenMaterial() {
        const opacity = APP.settings.getFloat('schatten_extra_transparenz',0.2);
        this.material = new THREE.MeshPhongMaterial({color: 0x000000, transparent: true, opacity});
        this.material.visible = true;
    }

    setEdgeMaterial(materialArtikelnummerChanged, kantenfarbe) {
        if (kantenfarbe == null) {
            if (this.edgeLines) {
                this.remove(this.edgeLines);
                this.edgeLines = null;
            }
        } else {
            const color = new THREE.Color(kantenfarbe);
            if (!this.edgeLines) {
                const geo = this.vsData.edgesGeometry || new THREE.EdgesGeometry(this.geometry);
                const mat = new THREE.LineBasicMaterial({ color, linewidth: 1, transparent: true, opacity: 0.3 });
                this.edgeLines = new THREE.LineSegments(geo, mat);
                this.edgeLines.hiddenInMassskizze = true;
                this.add(this.edgeLines);
            } else {
                if (materialArtikelnummerChanged) {
                    this.edgeLines.material.color = color;
                    this.edgeLines.material.needsUpdate = true;
                }
            }
        }
    }

    setMaterialFromProduct(materialArtikelnummerChanged, materialProduct) {

        if (!Commons.isEmpty(materialProduct) && (materialArtikelnummerChanged
            || this.material == null
            || !Commons.isEmpty(materialProduct.TextureUrl) && this.material.map == null)) {
            const texture = materialProduct.TextureUrl ? this.loadTexture(materialProduct.TextureUrl) : undefined;
            if (texture) {
                texture.offset.copy(this.getTextureOffset());
                texture.wrapS = THREE.MirroredRepeatWrapping;
                texture.wrapT = THREE.MirroredRepeatWrapping;
                /* const repeat = 1 / materialProduct.TextureScale;
                const offset = this.getTextureOffset();
                this.geometry.attributes.uv.array = this.geometry.attributes.uv.array.map((uv) => uv * repeat + this.getTextureOffsetDim()); */
                const repeat = 1 / materialProduct.TextureScale;
                texture.repeat.set(repeat, repeat);
            }
            /* this.disposeMaterial(); */
            this.material = new THREE.MeshStandardMaterial({
                map: texture,
                /* envMap: APP.model.raum.envmap, */
                roughness: 0.7,
                metalness: 0
            });
            this.material.visible = !this.vsData.wireframe;
        }
    }

    disposeMaterial() {
        if (this.material) {
            this.material.dispose();
            if (this.material.map) {
                this.material.map.dispose();
            }
        }
    }

    getTextureOffset() {
        if (!this.textureOffset) {
            this.textureOffset = new THREE.Vector2(Math.random(), Math.random());
        }
        return this.textureOffset;
    }

    getTextureOffsetDim() {
        if (!this.textureOffsetDime) {
            this.textureOffsetDime = Math.random();
        }
        return this.textureOffsetDime;
    }

}
